import AService from '@/services/AService'

export default class I18nService extends AService {
  async getI18nOverride (locale) {
    const reponse = await this.http.get(`${this.baseUrl}/i18n/${locale}`)
    return reponse.data
  }
}
